import { emptySplitApi as api } from "../../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1AssessmentsPlansInterventionsList: build.query<
      ApiPortalV1AssessmentsPlansInterventionsListApiResponse,
      ApiPortalV1AssessmentsPlansInterventionsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/interventions/`,
        params: {
          assessment_period_action_plan_id:
            queryArg.assessmentPeriodActionPlanId,
          assessment_period_id: queryArg.assessmentPeriodId,
          leader_id: queryArg.leaderId,
        },
      }),
    }),
    apiPortalV1AssessmentsPlansInterventionsCreate: build.mutation<
      ApiPortalV1AssessmentsPlansInterventionsCreateApiResponse,
      ApiPortalV1AssessmentsPlansInterventionsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/interventions/`,
        method: "POST",
        body: queryArg.interventionActionPlan,
      }),
    }),
    apiPortalV1AssessmentsPlansInterventionsRetrieve: build.query<
      ApiPortalV1AssessmentsPlansInterventionsRetrieveApiResponse,
      ApiPortalV1AssessmentsPlansInterventionsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/interventions/${queryArg.id}/`,
      }),
    }),
    apiPortalV1AssessmentsPlansInterventionsUpdate: build.mutation<
      ApiPortalV1AssessmentsPlansInterventionsUpdateApiResponse,
      ApiPortalV1AssessmentsPlansInterventionsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/interventions/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.interventionActionPlan,
      }),
    }),
    apiPortalV1AssessmentsPlansInterventionsPartialUpdate: build.mutation<
      ApiPortalV1AssessmentsPlansInterventionsPartialUpdateApiResponse,
      ApiPortalV1AssessmentsPlansInterventionsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/interventions/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedInterventionActionPlan,
      }),
    }),
    apiPortalV1AssessmentsPlansInterventionsDestroy: build.mutation<
      ApiPortalV1AssessmentsPlansInterventionsDestroyApiResponse,
      ApiPortalV1AssessmentsPlansInterventionsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/interventions/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1AssessmentsPlansInterventionsListApiResponse =
  /** status 200  */ InterventionActionPlanRead[];
export type ApiPortalV1AssessmentsPlansInterventionsListApiArg = {
  assessmentPeriodActionPlanId?: number;
  assessmentPeriodId?: number;
  leaderId?: number;
};
export type ApiPortalV1AssessmentsPlansInterventionsCreateApiResponse =
  /** status 201  */ InterventionActionPlanRead;
export type ApiPortalV1AssessmentsPlansInterventionsCreateApiArg = {
  interventionActionPlan: InterventionActionPlanWrite;
};
export type ApiPortalV1AssessmentsPlansInterventionsRetrieveApiResponse =
  /** status 200  */ InterventionActionPlanRead;
export type ApiPortalV1AssessmentsPlansInterventionsRetrieveApiArg = {
  /** A unique integer value identifying this assessment period action plan. */
  id: number;
};
export type ApiPortalV1AssessmentsPlansInterventionsUpdateApiResponse =
  /** status 200  */ InterventionActionPlanRead;
export type ApiPortalV1AssessmentsPlansInterventionsUpdateApiArg = {
  /** A unique integer value identifying this assessment period action plan. */
  id: number;
  interventionActionPlan: InterventionActionPlanWrite;
};
export type ApiPortalV1AssessmentsPlansInterventionsPartialUpdateApiResponse =
  /** status 200  */ InterventionActionPlanRead;
export type ApiPortalV1AssessmentsPlansInterventionsPartialUpdateApiArg = {
  /** A unique integer value identifying this assessment period action plan. */
  id: number;
  patchedInterventionActionPlan: PatchedInterventionActionPlanWrite;
};
export type ApiPortalV1AssessmentsPlansInterventionsDestroyApiResponse =
  unknown;
export type ApiPortalV1AssessmentsPlansInterventionsDestroyApiArg = {
  /** A unique integer value identifying this assessment period action plan. */
  id: number;
};
export type TypeOf3B0Enum = 1 | 2 | 3 | 4;
export type InterventionActionPlan = {
  organization?: number;
  recommendation?: number | null;
  recommendation_name?: string;
  recommendation_json?: any | null;
  assessment_period_id: number;
  team?: number | null;
  debrief_schedule_id?: number | null;
  leader?: number | null;
  type_of?: TypeOf3B0Enum;
  notes?: string | null;
};
export type InterventionActionPlanRead = {
  id: number;
  organization?: number;
  recommendation?: number | null;
  recommendation_name?: string;
  recommendation_json?: any | null;
  template: string;
  assessment_period_id: number;
  team?: number | null;
  debrief_schedule_id?: number | null;
  tasks: string;
  /** Return total number of tasks for this action plan */
  total_task_count: number;
  /** Return number of completed tasks for this action plan */
  completed_task_count: number;
  /** Return percentage of tasks completed */
  percent_complete: number;
  leader?: number | null;
  type_of?: TypeOf3B0Enum;
  notes?: string | null;
};
export type InterventionActionPlanWrite = {
  organization?: number;
  recommendation?: number | null;
  recommendation_name?: string;
  recommendation_json?: any | null;
  assessment_period_id: number;
  team?: number | null;
  team_id?: number | null;
  debrief_schedule_id?: number | null;
  leader?: number | null;
  type_of?: TypeOf3B0Enum;
  notes?: string | null;
};
export type PatchedInterventionActionPlan = {
  organization?: number;
  recommendation?: number | null;
  recommendation_name?: string;
  recommendation_json?: any | null;
  assessment_period_id?: number;
  team?: number | null;
  debrief_schedule_id?: number | null;
  leader?: number | null;
  type_of?: TypeOf3B0Enum;
  notes?: string | null;
};
export type PatchedInterventionActionPlanRead = {
  id?: number;
  organization?: number;
  recommendation?: number | null;
  recommendation_name?: string;
  recommendation_json?: any | null;
  template?: string;
  assessment_period_id?: number;
  team?: number | null;
  debrief_schedule_id?: number | null;
  tasks?: string;
  /** Return total number of tasks for this action plan */
  total_task_count?: number;
  /** Return number of completed tasks for this action plan */
  completed_task_count?: number;
  /** Return percentage of tasks completed */
  percent_complete?: number;
  leader?: number | null;
  type_of?: TypeOf3B0Enum;
  notes?: string | null;
};
export type PatchedInterventionActionPlanWrite = {
  organization?: number;
  recommendation?: number | null;
  recommendation_name?: string;
  recommendation_json?: any | null;
  assessment_period_id?: number;
  team?: number | null;
  team_id?: number | null;
  debrief_schedule_id?: number | null;
  leader?: number | null;
  type_of?: TypeOf3B0Enum;
  notes?: string | null;
};
export const {
  useApiPortalV1AssessmentsPlansInterventionsListQuery,
  useApiPortalV1AssessmentsPlansInterventionsCreateMutation,
  useApiPortalV1AssessmentsPlansInterventionsRetrieveQuery,
  useApiPortalV1AssessmentsPlansInterventionsUpdateMutation,
  useApiPortalV1AssessmentsPlansInterventionsPartialUpdateMutation,
  useApiPortalV1AssessmentsPlansInterventionsDestroyMutation,
} = injectedRtkApi;
